<template>
  <div class="h-full w-full text-white bg-image radius relative">
    <div
      class="bg-black flex flex-col justify-center h-full w-full px-20 bg-opacity-70 radius"
    >
      <VueSlickCarousel v-bind="settings">
        <div v-for="(feature, index) in features" :key="index">
          <p class="text-9xl font-bold pb-3">{{ feature.desc }}</p>
          <!-- <p class="text-9xl pb-3">{{ feature.title }}</p> -->
        </div>
      </VueSlickCarousel>
    </div>

    <div class="absolute bottom-0 w-full mb-8 text-white">
      <p class="text-center text-sm opacity-70">
        &copy; Copyright {{ new Date().getFullYear() }}.
        <a class="text-primary" href="https://talantahrm.com">Talanta HR.</a>
        All Rights Reserved
      </p>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  name: "Features",
  components: { VueSlickCarousel },
  data() {
    return {
      features: [
        {
          title: "",
          desc: "Streamlining HR, streamlining business.",
        },
        {
          title: "",
          desc: "Unlocking the full potential of the workforce.",
        },
        {
          title: "",
          desc: "Empowering employees, elevating the business",
        },
        {
          title: "",
          desc: "Efficient HR processes, effective business results.",
        },
        {
          title: "",
          desc: "Simplifying HR, simplifying life.",
        },
        {
          title: "",
          desc: "Better HR management, better business outcomes.",
        },
      ],

      settings: {
        dots: true,
        arrows: false,
        autoplay: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    };
  },
};
</script>

<style scoped>
.bg-image {
  background-image: url("~@/assets/images/login.jpg");
  background-size: cover;

  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
}

.radius {
  border-top-right-radius: 5%;
  border-bottom-right-radius: 5%;
}
</style>
